<template>
  <div>
    <Layout :pagetitle="$t('Affiliates')">
      <div class="card">
        <div class="card-header">
          <div>
            <b-row>
              <b-col md="6">
                <h4 class="card-title" v-html="$t('Affiliates')" />
              </b-col>
            </b-row>
          </div>
        </div>
        <div class="card-body">
          <div>
            <b-row>
              <div class="col-md-4">
                <span>
                  <label>{{ $t('Search') }}</label>
                  <b-form-input v-model="search" type="text" id="search-table-input" :placeholder="$t('Search')" />
                </span>
              </div>
              <div class="col-md-4">
                <span>
                  <label>{{ $t('Sub Brand') }}</label>
                  <subBrandsSelector :mode="'single'" :modelValue="idSubBrand" @onChange="setSubBrand" />
                </span>
              </div>
              <div class="col-md-4">
                <span>
                  <label>{{ $t('Payment Type') }}</label>
                  <b-form-select v-model="paymentType" :options="paymentTypeOptions" />
                </span>
              </div>
              <div class="col-md-12 mt-2">
                <div class="d-flex justify-content-end">
                  <button size="sm" @click="showModalSetPaymentType" class="btn btn-secondary m-1">
                    {{ $t('Set Payment Type') }}
                  </button>
                  <button size="sm" @click="createAffiliate" class="btn btn-primary m-1">
                    {{ $t('Create') }}
                  </button>
                </div>
              </div>
            </b-row>
            <b-row>
              <b-col>
                <Table
                  :title="''"
                  :items="affiliates"
                  :columns="columns"
                  :totalItems="totalItems"
                  :showButtons="true"
                  :searchable="false"
                  :isCard="false"
                  :editable="true"
                  :removable="true"
                  :showPagination="true"
                  @onSearch="onSearch"
                  @onEdit="editAffiliate"
                  @onCreate="createAffiliate"
                  @onRemove="onRemove"
                  @customAction="openLinkedCustomers"
                  @onChangePage="changePage"
                  :customActionBtn="true"
                  :customActionName="'Clientes Vinculados'"
                  :selectable="true"
                  @onSelect="setSelectedAffiliates"
                  :keyToSelect="'id'"
                  :selectedItems="selectedAffiliates"
                  :selectAllButton="true"
                  @onSelectAll="selectAllAffiliates"
                  :canHideSelectAllButton="false"
                />
              </b-col>
            </b-row>
            <b-row>
              <b-col class="text-right">
                <small class="text-muted">{{ totalItems }} {{ $t('Affiliates') }}</small>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </Layout>

    <b-modal v-model="isShowModalSetPaymentType" :title="$t('Set Payment Type')" hide-footer>
      <b-row>
        <b-col>
          <div class="col-md-12">
            <span>
              <label>{{ $t('Payment Type') }}</label>
              <b-form-select v-model="paymentTypeToChange" :options="paymentTypeOptions" />
            </span>
          </div>
        </b-col>
      </b-row>
      <br />
      <br />

      <h3 class="text-center" v-if="paymentTypeToChange">
        {{ $t('Alterar') }} {{ selectedAffiliates.length }} {{ $t('afiliado(s) para o tipo de pagamento') }}: ({{
          paymentTypeToChange
        }}).
        <br />
        <br />
        {{ $t('Deseja continuar?') }}
      </h3>

      <b-row>
        <b-col class="d-flex justify-content-end">
          <div>
            <b-btn
              v-if="paymentTypeToChange"
              @click="
                modalConfirmar = true;
                isShowModalSetPaymentType = false;
              "
              class="btn btn-primary"
            >
              Ok
            </b-btn>
          </div>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal v-model="modalConfirmar" :title="$t('Set Payment Type')" hide-footer>
      <h3>{{ $t('Deseja continuar?') }}</h3>

      <b-row>
        <b-col class="d-flex justify-content-end">
          <div>
            <b-btn @click="setPaymentType" class="btn btn-primary">
              {{ $t('Yes') }}
            </b-btn>
          </div>
        </b-col>
      </b-row>
    </b-modal>

    <LinkedCustomersModal ref="linkedCustomersModal" />
  </div>
</template>

<script>
import Layout from '@/views/layouts/main';
import Table from '@/components/bootstrap/table';
import subBrandsSelector from '@/components/selectors/subBrandsSelector';
import LinkedCustomersModal from './LinkedCustomersModal.vue';

export default {
  components: { Layout, Table, subBrandsSelector, LinkedCustomersModal },
  data() {
    return {
      search: '',
      page: 1,
      idSubBrand: null,
      totalItems: 0,
      columns: [
        {
          key: 'name',
          label: this.$t('Name')
        },
        {
          key: 'sub_brand',
          label: this.$t('Sub Brand')
        },
        {
          key: 'payment_type',
          label: this.$t('Payment Type')
        },
        {
          key: 'token',
          label: 'Token'
        }
      ],
      affiliates: [],
      paymentType: null,
      paymentTypeOptions: [
        { value: null, text: this.$t('Select') },
        { value: 'manual', text: this.$t('Manual') },
        { value: 'automatic', text: this.$t('Automático') }
      ],
      selectedAffiliates: [],
      isShowModalSetPaymentType: false,
      paymentTypeToChange: null,
      modalConfirmar: false
    };
  },
  mounted() {
    this.getAffiliates();
    this.enableSearch();
  },
  watch: {
    paymentType() {
      this.onSearch(this.search);
    }
  },
  methods: {
    setSubBrand(id = null) {
      this.idSubBrand = id;
      this.onSearch(this.search);
    },
    changePage(page) {
      this.page = page;
      this.getAffiliates();
    },
    onRemove(affiliate) {
      this.$api.destroy(`api/affiliate/${affiliate.id}`).then(() => {
        this.$customAlert({
          type: 'success',
          msg: this.$t('Affiliate was excluded with success')
        });
        this.getAffiliates();
      });
    },
    getAffiliates() {
      this.selectedAffiliates = [];

      let payload = { search: this.search, page: this.page };

      if (this.idSubBrand) {
        payload['idSubBrand'] = this.idSubBrand;
      }

      if (this.paymentType) {
        payload['paymentType'] = this.paymentType;
      }

      this.$store.commit('SET_LOADING', true);
      this.$api
        .get('api/affiliate', payload)
        .then((res) => {
          this.$store.commit('SET_LOADING', false);
          this.page = 1;
          this.affiliates = (res.data?.results || []).map((a) => {
            return {
              ...a,
              sub_brand: a.sub_brand?.name
            };
          });
          this.totalItems = res.data.total;
        })
        .catch((err) => {
          this.$store.commit('SET_LOADING', false);
          console.log(err);
        });
    },
    createAffiliate() {
      this.$router.push({
        name: 'affiliateCreate'
      });
    },
    editAffiliate(affiliate) {
      this.$router.push({
        name: 'affiliateUpdate',
        params: {
          id: affiliate.id
        }
      });
    },
    openLinkedCustomers(affiliate) {
      this.$refs.linkedCustomersModal.show(affiliate);
    },
    onSearch(search = '') {
      this.search = search;
      this.getAffiliates();
    },
    enableSearch() {
      let input_search = document.getElementById('search-table-input');
      input_search.addEventListener(
        'keyup',
        this.$utils.debounce(() => {
          this.onSearch(this.search);
        })
      );
    },
    setSelectedAffiliates(selecteds) {
      this.selectedAffiliates = selecteds;
    },
    selectAllAffiliates(isAllSelected) {
      if (isAllSelected === true) {
        this.selectedAffiliates = this.affiliates.map((a) => a.id);
      } else {
        this.selectedAffiliates = [];
      }
    },
    showModalSetPaymentType() {
      if (this.selectedAffiliates?.length === 0) {
        this.$customAlert({
          type: 'error',
          msg: this.$t('Please select at least one affiliate')
        });
        return;
      }

      this.isShowModalSetPaymentType = true;
    },
    setPaymentType() {
      this.modalConfirmar = false;
      this.isShowModalSetPaymentType = false;
      this.$store.commit('SET_LOADING', true);
      this.$api
        .post('api/affiliate/setPaymentType', {
          affiliateIds: this.selectedAffiliates,
          paymentType: this.paymentTypeToChange
        })
        .then(() => {
          this.$store.commit('SET_LOADING', false);
          this.$customAlert({
            type: 'success',
            msg: this.$t('Payment Type was set with success')
          });
          this.getAffiliates();
        })
        .catch((err) => {
          this.$store.commit('SET_LOADING', false);
          this.$customAlert({
            type: 'error',
            msg: err?.response?.data?.message || this.$t('Error')
          });
        });
    }
  }
};
</script>

<style></style>
